<template>
    <v-img
      :src="imageUrl"
      class="mb-4"
      :height="computedImageHeight"
      contain
      style="margin: 0 auto;"
    ></v-img>
    <div class="text-container">
      <div class="title" :style="{ color: foregroundColor }">{{ title }}</div>
      <div class="subtitle" :style="{ color: foregroundColor }">{{ subtitle }}</div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      imageUrl: {
        type: String,
        default: '/assets/logo.jpg',
      },
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      foregroundColor: {
        type: String,
        default: 'rgb(0, 0, 0)',
      },
      imageSize: {
        type: String,
        default: 'small',
        validator: value => ['small', 'large'].includes(value),
      }
    },
    computed: {
      computedImageHeight() {
        return this.imageSize === 'large' ? '105px' : '65px';
      }
    }
  };
  </script>
  
<style scoped>
.text-container {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
}

.title {
  font-size: 24px;
  font-weight: 700;
  display: block;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.subtitle {
  font-size: 15px;
  font-weight: 400;
  display: block;
  line-height: 1.6;
  opacity: 0.8;
}
</style>
